var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Toilet Man"
  }, /*#__PURE__*/React.createElement("g", {
    id: "toilet-man--travel-wayfinder-toilet-man"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 11.625C18.1317 11.6456 18.7612 11.5389 19.3509 11.3114C19.9406 11.0838 20.4786 10.74 20.9328 10.3004C21.3869 9.86073 21.7481 9.33427 21.9947 8.75227C22.2414 8.17027 22.3685 7.54462 22.3685 6.91251C22.3685 6.28041 22.2414 5.65475 21.9947 5.07275C21.7481 4.49075 21.3869 3.96429 20.9328 3.52466C20.4786 3.08503 19.9406 2.74121 19.3509 2.51365C18.7612 2.28609 18.1317 2.17943 17.5 2.20001C16.2767 2.23986 15.1169 2.75381 14.2656 3.63323C13.4144 4.51264 12.9385 5.6886 12.9385 6.91251C12.9385 8.13642 13.4144 9.31238 14.2656 10.1918C15.1169 11.0712 16.2767 11.5852 17.5 11.625Z",
    stroke: "#797979",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.75 19.88C25.75 17.692 24.8808 15.5935 23.3336 14.0464C21.7865 12.4992 19.688 11.63 17.5 11.63C15.312 11.63 13.2135 12.4992 11.6664 14.0464C10.1192 15.5935 9.25 17.692 9.25 19.88V23.415H12.785L13.9625 32.845H21.0375L22.215 23.415H25.7525L25.75 19.88Z",
    stroke: "#797979",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.180238d7144f48f548b7ff55ac3fb5d2.svg";
export { ForwardRef as ReactComponent };